import { createStore, createEvent } from 'effector';
import { PortalNoteTemplate } from '@nx-frontend/shared/types';

interface NoteTemplateData {
  globalId: string;
  template: PortalNoteTemplate;
  inited: boolean;
}

const initialState: NoteTemplateData[] = [];

const $noteTemplateStore = createStore<NoteTemplateData[]>(initialState);
const addNoteTemplateEvent = createEvent<NoteTemplateData>();

const inactivateInitTemplateByIdEvent = createEvent<string>();

$noteTemplateStore
  .on(addNoteTemplateEvent, (state, newNote) => [...state, newNote])
  .on(inactivateInitTemplateByIdEvent, (state, globalId) =>
    state.map((item) => (item.globalId === globalId && !item.inited ? { ...item, inited: true } : item))
  );

export { $noteTemplateStore, inactivateInitTemplateByIdEvent, addNoteTemplateEvent };
